<template>
  <v-dialog
    v-model="openDialog"
    content-class="dialogPDF"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    max-width="90%"
    @click:outside="close"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="viewFile()"><v-icon>mdi-eye</v-icon></v-btn>
          <v-btn dark text @click="downloadOriginalFile()">
            Arquivo Original
          </v-btn>
        </v-toolbar-items>
        <v-toolbar-items>
          <v-btn dark text @click="downloadFile(pdfFile)"> Salvar </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-row justify="center">
        <PDFJSViewerVue
          v-if="openDialog"
          :fileName="pdfFile"
          style="flex: 1"
          ref="viewpdf"
        />
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import PDFJSViewerVue from "@/views/components/PDFJSViewer/PDFJSViewer";
import axios from "axios";
export default {
  name: "ModalDialogVisualizacaoPdf",
  components: {
    PDFJSViewerVue,
  },
  data() {
    return {
      openDialog: false,
      blob: {},
    };
  },
  watch: {
    visivel: function (newDialogVisualizacao) {
      this.openDialog = newDialogVisualizacao;
    },
  },
  props: {
    pdfFile: Object,
    visivel: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
    downloadFile() {
      if (this.$refs.viewpdf.blobFile instanceof Blob) {
        const a = document.createElement("a");
        a.download =
          `${this.pdfFile?.nomeArquivoOriginal.toString().split(".")[0]}.pdf` ??
          "";
        a.href = URL.createObjectURL(this.$refs.viewpdf.blobFile);
        a.click();
        URL.revokeObjectURL(a.href);
      }
    },
    async downloadOriginalFile() {
      const result = await axios.get(this.pdfFile.caminhoVisualizacao, {
        responseType: "blob",
      });
      const blob = new Blob([result.data]);
      const a = document.createElement("a");
      a.download = this.pdfFile?.nomeArquivoOriginal ?? "";
      a.href = URL.createObjectURL(blob);
      a.click();
    },
    async viewFile() {
      window.open(this.pdfFile.caminhoVisualizacao, "_blank");
    },
  },
};
</script>
<style>
.dialogPDF {
  width: 100%;
  overflow: hidden;
}
</style>
